module.exports = __webpack_public_path__ + "img/epson-tm30.96496b14.png";